import {
    InputControl,
    NumberInput,
    TextInput,
    useMerchantConfig,
} from "@venuepos/react-common";
import { GQLayoutEntitySave } from "graphql-sdk";
import { isJSON, parseAmount } from "lib";
import { useTranslation } from "locales";
import React, { useCallback, useEffect, useState } from "react";
import { View } from "react-native";

export function BuyAccountFundsSubForm({
    values,
    setValue,
}: {
    values: GQLayoutEntitySave;
    setValue: (field, value) => void;
}) {
    const [t] = useTranslation();
    const merchantConfig = useMerchantConfig();

    const [externalId, setExternalId] = useState(
        isJSON(values.data)
            ? JSON.parse(values.data)?.externalId
            : values.data?.externalId
    );

    const [amount, setAmount] = useState(
        isJSON(values.data)
            ? JSON.parse(values.data)?.amount
            : values.data?.amount
    );

    const handleAmountChange = useCallback(
        newAmount => {
            const value = newAmount ? parseAmount(newAmount) : 0;
            setAmount(value);
            setValue(
                "data",
                JSON.stringify({
                    __typename: "BuyAccountFunds",
                    externalId: externalId,
                    amount: value,
                })
            );
        },
        [externalId, setValue]
    );

    const handleExternalIdChange = useCallback(
        (newExternalId: string) => {
            setExternalId(newExternalId);
            setValue(
                "data",
                JSON.stringify({
                    __typename: "BuyAccountFunds",
                    externalId: newExternalId,
                    amount: amount,
                })
            );
        },
        [amount, setValue]
    );

    useEffect(() => {
        setValue(
            "data",
            JSON.stringify({
                __typename: "BuyAccountFunds",
            })
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // The dependency array is empty on purpose

    return (
        <>
            <View>
                <InputControl
                    description={t(
                        "layout.function_button_form.buy_funds_amount",
                        "Leave field blank to let the amount be decided by the cashier"
                    )}
                >
                    <NumberInput
                        label={t("common.amount", "Amount")}
                        value={amount ? amount / 100 : null}
                        onChange={handleAmountChange}
                        min={0}
                        unit={merchantConfig.currency}
                    />
                </InputControl>
                <InputControl>
                    <TextInput
                        label={t(
                            "backoffice.common.external_id",
                            "External ID"
                        )}
                        placeholder={t(
                            "backoffice.common.enter_external_id",
                            "Enter external identifier"
                        )}
                        value={externalId || ""}
                        onChangeText={handleExternalIdChange}
                        onClear={() => {
                            handleExternalIdChange("");
                        }}
                    />
                </InputControl>
            </View>
        </>
    );
}
